import { Package } from 'components/billing/common/types';
import { useGetPackages } from 'components/billing/context/useBilling';
import { useMemo } from 'react';

export default function useGetPackageBySKU(sku: string): Package | undefined {
  const { data: packages = [] } = useGetPackages();

  return useMemo(() => {
    return packages.find((p) => p.sku === sku);
  }, [packages, sku]);
}
